<script lang="ts" setup>
import { computed } from 'vue';
import { globalLocale } from '@/shared/lib/i18n';
import ja from './locales/ja';
import en from './locales/en';

const GUIDE_URL = 'https://air-luggage.net/';
const FAQ_URL = 'https://air-luggage.net/#faq';
const TERMS_URL = 'https://air-luggage.net/legal/';

// sharedレイヤーのglobalLocaleを参照し、翻訳メッセージをcomputedで取得（FSD準拠）
const messages = computed(() => (globalLocale.value === 'ja' ? ja : en));
</script>

<template>
    <v-main>
        <slot></slot>
    </v-main>

    <v-footer app color="cardHeader" class="justify-space-evenly py-4">
        <v-btn
            variant="text"
            size="small"
            class="text-body-1 font-weight-medium text-white"
            :href="GUIDE_URL"
            target="_blank"
            rel="noopener noreferrer"
        >
            {{ messages.footer.guide }}
        </v-btn>
        <v-btn
            variant="text"
            size="small"
            class="text-body-1 font-weight-medium text-white"
            :href="FAQ_URL"
            target="_blank"
            rel="noopener noreferrer"
        >
            {{ messages.footer.faq }}
        </v-btn>
        <v-btn
            variant="text"
            size="small"
            class="text-body-1 font-weight-medium text-white"
            :href="TERMS_URL"
            target="_blank"
            rel="noopener noreferrer"
        >
            {{ messages.footer.termsOfService }}
        </v-btn>
    </v-footer>
</template>
